import Vue from 'vue'
import VueRouter from 'vue-router'
import moment from 'moment'
import 'moment/locale/zh-cn'
import _ from 'lodash'
import NProgress from 'nprogress' // progress bar
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'ABzxFvOF6dknCwEDpUyRo1sCMYvZRzQE'
})
import '@/core/component_use'
import App from './App.vue'

import '@/assets/css/index.less'
import store from './store'
import '@/core/directives'
import router from './router'

import axiosInstance from './plugins/axios'
import permissionWrapper from './plugins/permission'
import popErrorPageWrapper from './plugins/popErrorPage'
import queryStateWrapper from './plugins/queryState'
import keepAliveCtrlWrapper from './plugins/keepAliveCtrl'
import collectionWrapper from './plugins/collection'
import modalWrapper from './plugins/modal'
import VueDND from 'awe-dnd'

import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

import {
  Form, FormItem, Dialog, Collapse, CollapseItem, Upload, Progress, Popover, Image, Divider, Row, Col, Select, Option, Input,InputNumber, DatePicker, Radio, RadioGroup, RadioButton, Button, Checkbox,
  CheckboxButton,
  CheckboxGroup,
} from 'element-ui';
Vue.use(Dialog)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Upload)
Vue.use(Progress)
Vue.use(Popover)
Vue.use(Image)
Vue.use(Divider)
Vue.use(Row)
Vue.use(Col)
Vue.use(Select)
Vue.use(Option)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(DatePicker)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)

function getCurrentContext() {
  return {
    app: app || Vue.prototype,
    store,
    router,
  }
}


// const originalAddEventListener = EventTarget.prototype.addEventListener;
// EventTarget.prototype.addEventListener = function(type, listener, options) {
//   if (type === 'DOMNodeInserted') {
//     console.warn('DOMNodeInserted event listener detected:', this, listener);
//   }
//   return originalAddEventListener.apply(this, arguments);
// };

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(VueDND)

moment.locale('zh-cn')
// 外部库
Vue.prototype.$moment = moment
Vue.prototype.$progress = NProgress
Vue.prototype._ = _
//
Vue.prototype.$axios = axiosInstance
Vue.prototype.$queryState = queryStateWrapper(getCurrentContext())
Vue.prototype.$popErrorPage = popErrorPageWrapper(getCurrentContext())
Vue.prototype.$queryState = queryStateWrapper(getCurrentContext())
Vue.prototype.$routex = keepAliveCtrlWrapper(getCurrentContext())
Vue.prototype.$collection = collectionWrapper(getCurrentContext())
Vue.prototype.$modal = modalWrapper(getCurrentContext())

// Vue.prototype.ERROR_IMG_SRC = require('./assets/error_img.jpg')

permissionWrapper(getCurrentContext())
const app = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

export { app }
